import React from 'react';
import CustomDropdown from "../../reusableComponents/CustomDropdown";
import '../../../css/gardenManagerStylings/journalSection/AddJournalStyling.css';

const MOODS = [
    { value: 'inspired', label: 'Inspired' },
    { value: 'productive', label: 'Productive' },
    { value: 'determined', label: 'Determined' },
    { value: 'curious', label: 'Curious' },
    { value: 'excited', label: 'Excited' },
    { value: 'adventurous', label: 'Adventurous' },
    { value: 'playful', label: 'Playful' },
    { value: 'confident', label: 'Confident' },
    { value: 'peaceful', label: 'Peaceful' },
    { value: 'grateful', label: 'Grateful' },
    { value: 'hopeful', label: 'Hopeful' },
    { value: 'nostalgic', label: 'Nostalgic' },
    { value: 'reflective', label: 'Reflective' },
    { value: 'content', label: 'Content' },
    { value: 'melancholy', label: 'Melancholy' },
    { value: 'sentimental', label: 'Sentimental' },
    { value: 'tired', label: 'Tired' },
    { value: 'overwhelmed', label: 'Overwhelmed' },
    { value: 'discouraged', label: 'Discouraged' },
    { value: 'anxious', label: 'Anxious' },
    { value: 'impatient', label: 'Impatient' },
    { value: 'disappointed', label: 'Disappointed' },
    { value: 'stressed', label: 'Stressed' },
    { value: 'moody', label: 'Moody' },
    { value: 'grounded', label: 'Grounded' },
    { value: 'rejuvenated', label: 'Rejuvenated' },
    { value: 'earthy', label: 'Earthy' },
    { value: 'blooming', label: 'Blooming' },
    { value: 'analytical', label: 'Analytical' },
    { value: 'experimental', label: 'Experimental' },
    { value: 'observant', label: 'Observant' },
    { value: 'skeptical', label: 'Skeptical' },
    { value: 'surprised', label: 'Surprised' },
    { value: 'curious', label: 'Curious' }
];

const MOOD_INTENSITIES = [
    { value: '1', label: 'No particular intensity' },
    { value: '2', label: 'Mild' },
    { value: '3', label: 'Moderate' },
    { value: '4', label: 'Intense' }
];

const PRIVACY = [
    { value: 'private', label: 'Private' },
    { value: 'public', label: 'Public' },
    { value: 'friends', label: 'Friends Only' },
]

const AddJournalComponent = ({ garden, plants, journalRefresh }) => {

    const [journalEntryTitle, setJournalEntryTitle] = React.useState("");
    const [journalEntryContent, setJournalEntryContent] = React.useState("");
    const [journalEntryMood, setJournalEntryMood] = React.useState("");
    const [journalEntryMoodIntensity, setJournalEntryMoodIntensity] = React.useState("");
    const [journalEntryPrivacy, setJournalEntryPrivacy] = React.useState("");
    // const [journalEntryPlantRelation, setJournalEntryPlantRelation] = React.useState("");

    const [statusMessage, setStatusMessage] = React.useState("");
    const [statusType, setStatusType] = React.useState(""); // "success" or "error"

    const handleTitleChange = React.useCallback((e) => {
        setJournalEntryTitle(e.target.value);
    }, []);

    const handleContentChange = React.useCallback((e) => {
        setJournalEntryContent(e.target.value);
    }, []);

    const handleMoodChange = React.useCallback((mood) => {
        setJournalEntryMood(mood.value);
    }, []);

    const handleIntensityChange = React.useCallback((intensity) => {
        setJournalEntryMoodIntensity(intensity.value);
    }, []);

    const handlePrivacyChange = React.useCallback((privacy) => {
        setJournalEntryPrivacy(privacy.value);
    }, []);



    const handleSubmitJournal = React.useCallback(async () => {
        // Clear any existing status messages
        setStatusMessage("");
        setStatusType("");

        const journalData = {
            title: journalEntryTitle,
            content: journalEntryContent,
            mood: journalEntryMood,
            mood_intensity: journalEntryMoodIntensity ? parseInt(journalEntryMoodIntensity) : 0,
            garden_id: garden?.id,
            privacy: journalEntryPrivacy
        };

        console.log('Submitting journal entry:', journalData);

        try {
            const response = await fetch('/api/journal/addJournalEntry', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include', // Sends cookies automatically
                body: JSON.stringify(journalData)
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Failed to create journal entry');
            }

            const result = await response.json();

            // Reset form
            setJournalEntryTitle("");
            setJournalEntryContent("");
            setJournalEntryMood("");
            setJournalEntryMoodIntensity("");
            setJournalEntryPrivacy("");

            // refresh journal messages after succeessfully adding one
            journalRefresh();

            // Set success message
            setStatusMessage("Journal saved successfully!");
            setStatusType("success");

            // Clear the message after 5 seconds
            setTimeout(() => {
                setStatusMessage("");
                setStatusType("");
            }, 5000);

        } catch (error) {
            console.error('Error saving journal:', error);

            // Set error message
            setStatusMessage(error.message || "Failed to save journal entry. Please try again.");
            setStatusType("error");

            // Clear the message after 5 seconds
            setTimeout(() => {
                setStatusMessage("");
                setStatusType("");
            }, 5000);
        }
    }, [garden?.id, journalEntryContent, journalEntryMood, journalEntryMoodIntensity, journalEntryPrivacy, journalEntryTitle]);

    return (
        <div className={`add-journal-body`}>
            <div className={`garden-manager-add-journal-title-input`}>
                <div className={`add-journal-field add-journal-value-field`}>
                    <label className="add-new-journal-field-title">
                        Title *
                    </label>
                    <input
                        type="text"
                        value={journalEntryTitle}
                        onChange={handleTitleChange}
                        placeholder="Enter title..."
                        className="journal-text-input"
                        required
                    />
                </div>
            </div>

            <div className={`add-journal-field`}>
                <label className="add-new-journal-field-title">
                    Mood
                </label>
                <CustomDropdown
                    options={MOODS}
                    value={journalEntryMood}
                    onChange={handleMoodChange}
                    placeholder="Select a mood..."
                    className="garden-dropdown-custom"
                />
            </div>

            <div className={`add-journal-field`}>
                <label className="add-new-journal-field-title">
                    Mood Intensity
                </label>
                <CustomDropdown
                    options={MOOD_INTENSITIES}
                    value={journalEntryMoodIntensity}
                    onChange={handleIntensityChange}
                    placeholder="Select a mood intensity..."
                    className="garden-dropdown-custom"
                />
            </div>

            <div className={`add-journal-field`}>
                <label className="add-new-journal-field-title">
                    Privacy *
                </label>
                <CustomDropdown
                    options={PRIVACY}
                    value={journalEntryPrivacy}
                    onChange={handlePrivacyChange}
                    placeholder="Select a privacy setting..."
                    className="garden-dropdown-custom"
                />
            </div>

            <div className={`garden-manager-add-journal-description-input`}>
                <div className={`add-journal-field add-journal-value-field`}>
                    <label className="add-new-journal-field-title">
                        Content *
                    </label>
                    <textarea
                        value={journalEntryContent}
                        onChange={handleContentChange}
                        placeholder="Write like you never wrote before..."
                        className="journal-text-input"
                        rows={3}
                    />
                </div>
            </div>


            {/* Submit Button */}
            <div className={`add-journal-submit-container`}>
                <div className="status-message-container">
                    {statusMessage && (
                        <div className={`status-message status-message-${statusType}`}>
                            {statusMessage}
                        </div>
                    )}
                </div>
                <button
                    onClick={handleSubmitJournal}
                    className="add-journal-submit-button"
                    disabled={!journalEntryTitle || !journalEntryContent || !journalEntryPrivacy}
                >
                    Save Journal
                </button>
            </div>

        </div>
    )
}

export default AddJournalComponent;